<template>
  <div class="game-core">
    <div class="game-core__body">
      <game-header class="container" />
      <router-view />
    </div>
  </div>
</template>

<script>
import GameHeader from 'Root/pages/game/components/GameHeader.vue';
/*
Корневой компонент представления игры, аналог старого GameView
содержит логику и данные необходимые для всех подразделов
*/
export default {
  name: 'GameCore',

  components: {
    GameHeader,
  },
};
</script>

<style lang="scss">
  .game-core__body {
    position: relative;
  }

  .game-core {
    .container {
      padding: 12px var(--padding);
    }
  }

  @media screen and #{$screen-more-or-1024} {
    .game-core {
      .container {
        --padding: 3%;

        padding: 15px var(--padding);
      }
    }
  }
</style>
